import useLayoutStore from '@/store/useLayoutStore'

export const DEFAULT_BOTTOM_OFFSET = 50
export const DEFAULT_TOP_OFFSET = 100

/**
 * Hook for getting offsets from Telegram SDK
 * Offsets are managed in OffsetsProvider and stored in useLayoutStore
 *
 * - In SHOW_MOCK_OFFSETS=true mode: mock values (100px/50px)
 * - In normal mode: real values from SDK with fallback (45px/30px)
 * - Reactively updates when safe area changes
 */
const useOffsets = () => {
  const offsets = useLayoutStore((state) => state.offsets)
  return offsets
}

export default useOffsets
